export default function Support() {
  const styles = {
    content: {
      maxWidth: 800,
      margin: '0 auto',
      color: '#fff',
    },
    section: {
      background: 'transparent',
      backdropFilter: 'none',
      borderRadius: 16,
      padding: 32,
      marginBottom: 24,
      border: 'none',
    },
    title: {
      fontSize: 32,
      fontWeight: 800,
      marginBottom: 24,
      color: '#fff',
    },
    subtitle: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 16,
      color: '#fff',
    },
    text: {
      fontSize: 16,
      lineHeight: 1.8,
      opacity: 1,
      marginBottom: 16,
      color: '#fff',
    },
    link: {
      color: '#fff',
      textDecoration: 'underline',
    },
  };

  return (
    <div style={styles.content}>
      <h1 style={styles.title}>Support</h1>

      {/* Submit a Ticket — GHL form embed (no card wrapper so it blends with page background) */}
      <div style={{ marginBottom: 24, overflow: 'hidden' }}>
        <h2 style={styles.subtitle}>Submit a Ticket</h2>
        <p style={{ ...styles.text, marginBottom: 16 }}>
          Fill out the form below and we'll get back to you within 24 hours on business days.
          Prefer direct contact? Email us at{' '}
          <a href="mailto:inbox.sentinel@hello.miltonecom.com" style={styles.link}>
            inbox.sentinel@hello.miltonecom.com
          </a>
          {' '}or call{' '}
          <a href="tel:+18662593033" style={styles.link}>+1 (866) 259-3033</a>.
        </p>

        <iframe
          src="https://link.miltonecom.com/widget/form/RkEvqTyBdu1djwFLNVCI"
          style={{
            width: '100%',
            height: 1180,
            border: 'none',
            borderRadius: 0,
            display: 'block',
            overflow: 'hidden',
            background: 'transparent',
            boxShadow: 'none',
          }}
          id="inline-RkEvqTyBdu1djwFLNVCI"
          scrolling="no"
          data-layout='{"id":"INLINE"}'
          data-trigger-type="alwaysShow"
          data-trigger-value=""
          data-activation-type="alwaysActivated"
          data-activation-value=""
          data-deactivation-type="neverDeactivate"
          data-deactivation-value=""
          data-form-name="Sentinel Support Form"
          data-height="undefined"
          data-layout-iframe-id="inline-RkEvqTyBdu1djwFLNVCI"
          data-form-id="RkEvqTyBdu1djwFLNVCI"
          title="Sentinel Support Form"
        />
        <script src="https://link.miltonecom.com/js/form_embed.js" />
      </div>

      {/* FAQ */}
      <div style={styles.section}>
        <h2 style={styles.subtitle}>Frequently Asked Questions</h2>

        <div style={{ marginBottom: 24 }}>
          <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8, color: '#fff' }}>
            Will Inbox Sentinel delete legitimate emails?
          </h3>
          <p style={styles.text}>
            No. Inbox Sentinel only removes high-confidence spam based on deterministic rules.
            Legitimate customer emails are never touched. If you notice any issues, please contact support immediately.
          </p>
        </div>

        <div style={{ marginBottom: 24 }}>
          <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8, color: '#fff' }}>
            What permissions does Inbox Sentinel require?
          </h3>
          <p style={styles.text}>
            Inbox Sentinel requires minimal permissions: reading conversations, removing spam messages,
            and managing spam-related contacts. We never access other parts of your CRM data.
          </p>
        </div>

        <div style={{ marginBottom: 24 }}>
          <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8, color: '#fff' }}>
            Can I customize what gets filtered?
          </h3>
          <p style={styles.text}>
            Currently, Inbox Sentinel uses proven filtering rules that work for most businesses.
            Custom filtering options are planned for a future release. Contact us if you have specific needs.
          </p>
        </div>

        <div style={{ marginBottom: 24 }}>
          <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8, color: '#fff' }}>
            How do I uninstall Inbox Sentinel?
          </h3>
          <p style={styles.text}>
            You can uninstall Inbox Sentinel at any time from your Marketplace Apps settings.
            All filtering will stop immediately.
          </p>
        </div>

        <div style={{ marginBottom: 24 }}>
          <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8, color: '#fff' }}>
            Is my data stored externally?
          </h3>
          <p style={styles.text}>
            No. Inbox Sentinel is stateless by default and does not store customer data externally.
            All processing happens in real-time when emails arrive.
          </p>
        </div>
      </div>

      {/* Additional Resources */}
      <div style={styles.section}>
        <h2 style={styles.subtitle}>Additional Resources</h2>
        <p style={styles.text}>
          • <a href="/docs" style={styles.link}>Documentation</a> - Complete setup and usage guide<br />
          • <a href="/privacy" style={styles.link}>Privacy Policy</a> - How we handle your data<br />
          • <a href="/terms-conditions" style={styles.link}>Terms &amp; Conditions</a> - Usage terms and agreements
        </p>
      </div>
    </div>
  );
}
